import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPI } from '../../API';
import { ActionTypes, useAppDispatch, useAppState } from '../../Store';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import SettingSidebarNav from '../../Components/SidebarNav/SettingSidebarNav';
import useAuthenticated from '../Dashboard/useAuthenticated';
import Badge from '../../Components/Badge';
export default function APISetting() {


    const { translate, language, setLanguage } = useTranslation();
    const api = useAPI();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const appState = useAppState();

    const { user } = appState;

    const { isAuthenticated, pathAfterLogin } = useAuthenticated();

    return (
        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="settings" contentPadding={false}>
                <div className='flex-1 flex-row h-full w-full'>
                    <SettingSidebarNav currentPage="integration" />
                    <div className='flex-1 flex flex-col ml-24 md:ml-72'>
                        <div className='flex flex-col p-2 md:p-4 lg:p-6 w-full'>
                            <h3 className='text-2xl font-bold'>{translate('setting.integration')}</h3>
                            <p className='text-md text-gray-500'>{translate('setting.integration_description')}</p>

                            <div className='flex flex-col mt-8'>
                                <div className='flex flex-col'>
                                    <h4 className='text-lg font-bold'>{translate('setting.integrations.client_key')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl'>{translate('setting.integrations.client_key_description')}</p>
                                    <div className='flex flex-row bg-gray-100 p-4 rounded-md mt-4 max-w-4xl'>
                                        {user?.client_key}
                                    </div>
                                </div>
                                <div className='flex flex-col mt-8'>
                                    <h4 className='text-lg font-bold'>{translate('setting.integrations.identify_api')}</h4>
                                    <div className='flex flex-row bg-gray-100 p-4 rounded-md mt-2 max-w-4xl gap-2 md:text-sm text-xs items-center'>
                                        <Badge text="POST" withoutRemove={true} color={'yellow'} />
                                        https://api.hoodleapp.com/api/contact/identify
                                    </div>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.integrations.identify_api_description_1')}</p>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl'>{translate('setting.integrations.identify_api_description_2')}</p>
                                    <ul className="list-disc list-inside mt-2 ml-4 space-y-2">
                                        <li><span className='font-bold bg-gray-100 p-1 rounded-md'>external_id</span>: {translate('setting.integrations.identify_api_description_external_id')}</li>
                                    </ul>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>
                                        {translate('setting.integrations.identify_api_description_3').split('data').map((part, index) => 
                                            index === 0 ? part : (
                                                <React.Fragment key={index}>
                                                    <span className='font-bold bg-gray-100 p-1 rounded-md text-black'>data</span>
                                                    {part.split('external_id').map((subPart, subIndex) => 
                                                        subIndex === 0 ? subPart : (
                                                            <React.Fragment key={`${index}-${subIndex}`}>
                                                                <span className='font-bold bg-gray-100 p-1 rounded-md text-black'>external_id</span>
                                                                {subPart}
                                                            </React.Fragment>
                                                        )
                                                    )}
                                                </React.Fragment>
                                            )
                                        )}
                                    </p>
                                </div>
                                <div className='flex flex-col mt-8 max-w-4xl'>
                                    <h4 className='text-lg font-bold'>{translate('setting.integrations.track_api')}</h4>
                                    <div className='flex flex-row bg-gray-100 p-4 rounded-md mt-2 max-w-4xl gap-2 md:text-sm text-xs items-center'>
                                        <Badge text="POST" withoutRemove={true} color={'yellow'} />
                                        https://api.hoodleapp.com/api/event/track
                                    </div>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.integrations.track_api_description_1')}</p>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl'>{translate('setting.integrations.track_api_description_2')}</p>
                                    <ul className="list-disc list-inside mt-2 ml-4 space-y-2">
                                        <li><span className='font-bold bg-gray-100 p-1 rounded-md'>name</span>: {translate('setting.integrations.track_api_description_name')}</li>
                                    </ul>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.integrations.track_api_description_3')}</p>
                                    <ul className="list-disc list-inside mt-2 ml-4 space-y-2">
                                        <li><span className='font-bold bg-gray-100 p-1 rounded-md'>data</span>: {translate('setting.integrations.track_api_description_data')}</li>
                                        <li><span className='font-bold bg-gray-100 p-1 rounded-md'>contact_external_id</span>: {translate('setting.integrations.track_api_description_contact_external_id')}</li>
                                    </ul>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-4'>{translate('setting.integrations.track_api_description_4')}</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </SidebarNav>
        </div>

    );
}